<template>
    <div class="add-to-cart-icon-component" @click="goToCart">
      <v-badge
        color="yellow"
        :content="getCount"
        offset-x="-2"
        offset-y="2"
        :dot="getCount == 0"
      >
        <v-icon icon="mdi-archive-outline" color="primary"></v-icon>
      </v-badge>
    </div>


</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AddToCartIconComponent',
  computed: {
    ...mapGetters('cartModule', ['getCount'])
  },
  methods: {
    goToCart() {
      this.$router.push({name: 'cartView'})
    }
  }
}
</script>

<style lang="scss" scoped>

.v-col {
    padding: 0 !important;
}
  .add-to-cart-icon-component {
    cursor: pointer;
    :deep(.v-badge) {
      &.v-badge--dot{
        .v-badge__badge {
          width: 0px;
          height: 0px;
          font-size: 0px;
        }
      }
      .v-badge__badge {
        @include nsb-font-header-bold;
        color: $ds-primary !important;
        font-size: 10px;
        line-height: 12px;
        padding-top: 5px;
      }
    }
  }
</style>